<template>
    <div class="py-4 container-fluid">
        <div v-if="!isLoading" class="row">
            <div class=" row">
                <div class="col-12">
                    <clients-table :clientes="clientes" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClientsTable from "./components/ClientsTable.vue";

export default {
    name: "clientes",
    components: {
        ClientsTable,
    },
    data() {
        return {
            isLoading: true,
            clientes: [],
        };
    },
    mounted() {
        this.obtenerListaDeClientes()
    },
    methods: {
        obtenerListaDeClientes() {
            this.$swal.fire({
                title: 'Cargando clientes...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });
            this.plainAuth
                .get(`/api/getclients`)
                .then((response) => {

                    if (response.data.message === "Consulta exitosa") this.clientes = response.data.users
                    else this.clientes = [];

                    //POR BORRAR
                    // this.clientes.map((cliente, index) => {
                    //     if (index > 3) {
                    //         cliente.sucursales = [
                    //             {
                    //                 id: 1,
                    //                 nombre: "Sucursal altiplano",
                    //                 direccion: "dufgsduygfuysdgfuysdgfuygasdfuygsdauyfgasduygfuyasdfguysuadfguysadgfyasdfguysdfysdyfyasdtfytasdfysdtf"
                    //             },
                    //             {
                    //                 id: 2,
                    //                 nombre: "Sucursal del norte",
                    //                 direccion: "fgasjufgsduygfuysdgfuysdgfuygsduyfgsduygfuysdgfuysdgfuysdgfuygsduyfgsdjfgfguysdgfsduygfuyjsdgfjuysdgfuysdgf"
                    //             },
                    //         ]
                    //     }
                    // })

                    this.isLoading = false;
                    this.$swal.close();
                })
                .catch(() => {
                    this.clientes = [];
                    this.isLoading = false;
                    this.$swal.close();
                })
        },
        refreshClientes() {
            this.plainAuth
                .get(`/api/getclients`)
                .then((response) => {
                    if (response.data.length !== 0) this.clientes = response.data;
                    else this.clientes = [];
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.clientes = [];
                    this.isLoading = false;
                    console.log(err);
                });
        }
    },
};
</script>